/**
 * 処理後物品目（大分類）
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/after_disposal_item_categories`

const search_after_disposal_item_category = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 処理後物大分類リスト
     * @param context
     * @param param1
     * @param param1.after_type { String } after_industrial: 廃棄物, after_recycling: 再資源化物
     * @param param1.category_name { String } 大分類名称
     * @param param1.query { String } キーワード
     * @param param1.page { Number } ページ番号
     * @return {Promise<unknown>}
     */
    index (context, { after_type, category_name, query , page, disable_pagination = false } = {}) {
      const params = {
        query: query,
        after_type: after_type,
        category_name: category_name,
        disable_pagination: disable_pagination,
        page: page,
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default search_after_disposal_item_category
